export const execute = (input: RequestInfo, init?: RequestInit): Promise<Response> => {
  return fetch(input, init)
}
